import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme
} from '@mui/material';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {toTestId} from '../utility/testIdUtil';

const AdmicityDialog = ({
    open,
    handleClose,
    title,
    contentText,
    children,
    actions,
    maxWidth = 'sm',
    contentSx,
    actionsSx,
    dialogSx
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            data-testid={typeof title === 'string' ? toTestId('dialog', title) : 'dialog'}
            fullWidth
            maxWidth={maxWidth}
            open={open}
            fullScreen={fullScreen}
            onClose={handleClose}
            sx={dialogSx}
        >
            <DialogTitle>{title}</DialogTitle>
            <IconButton
                data-testid="dialog-close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[600],
                }}
            >
                <CloseIcon/>
            </IconButton>
            <DialogContent sx={{paddingTop: 0, ...contentSx}}>
                <DialogContentText>
                    {contentText}
                </DialogContentText>
                {children}
            </DialogContent>
            <DialogActions sx={actionsSx}>
                {actions.map((action, index) =>
                    action.tooltip != null
                        ? <Box key={index} display="block" width={fullScreen ? '100%' : 'auto'}>
                            <Tooltip title={action.tooltip}>
                            <span>
                                <Button
                                    sx={action.sx ?? {color: '#186BBE'}}
                                    variant={action.variant}
                                    key={index}
                                    data-testid={toTestId('dialog-action', typeof action.label === 'string' ? action.label : index)}
                                    fullWidth={fullScreen}
                                    onClick={action.onClick}
                                    onMouseDown={action.onMouseDown}
                                    disabled={action.disabled ?? false}
                                    startIcon={action.startIcon ?? ''}
                                    type="submit"
                                >
                                {action.label}
                            </Button>
                            </span>
                            </Tooltip>
                        </Box>
                        : <Button
                            sx={action.sx ?? {color: '#186BBE'}}
                            variant={action.variant}
                            key={index}
                            data-testid={toTestId('dialog-action', typeof action.label === 'string' ? action.label : index)}
                            fullWidth={fullScreen}
                            onClick={action.onClick}
                            onMouseDown={action.onMouseDown}
                            disabled={action.disabled ?? false}
                            startIcon={action.startIcon ?? ''}
                            type="submit"
                        >
                            {action.label}
                        </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

AdmicityDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    contentText: PropTypes.string,
    children: PropTypes.node,
    actions: PropTypes.array,
    maxWidth: PropTypes.string,
    contentSx: PropTypes.object,
    actionsSx: PropTypes.object,
    dialogSx: PropTypes.object
};

export default AdmicityDialog;
